// Formattatori e etichette della pagina Impostazioni.
//
// Estratti da ImpostazioniPage.tsx (2026-08-27): erano cinque helper puri
// in fondo a un file da 1113 righe. Qui sono raggiungibili da un test
// senza montare la pagina intera.

/** Vocabolario tecnico della coda (``SyncStatus``, sync/schemas.py) tradotto
 *  per chi guarda la tabella per decidere se premere «Riprova» — stessa scelta
 *  dei badge leggibili di SyncDetailPanel. Uno stato sconosciuto resta grezzo
 *  invece di sparire: meglio una parola inglese che una cella vuota.
 *  I filtri dei bottoni continuano a confrontare ``job.status`` grezzo. */
export const JOB_STATUS_LABELS: Record<string, string> = {
  pending: "In attesa",
  claimed: "Preso in carico",
  running: "In corso",
  done: "OK",
  failed: "Errore",
  dead_letter: "Arreso (non riprova)",
  canceled: "Annullato",
};

export function jobStatusLabel(status: string): string {
  return JOB_STATUS_LABELS[status] ?? status;
}

export function jobStatusClass(status: string): string {
  if (status === "done") return "border-green-soft bg-green-soft text-ink";
  if (status === "failed" || status === "dead_letter")
    return "border-red-soft bg-red-soft text-ink";
  if (status === "running" || status === "claimed") return "border-blue-soft bg-blue-soft text-ink";
  if (status === "canceled") return "border-line bg-paper-2 text-ink-2";
  return "border-amber-soft bg-amber-soft text-ink";
}

export function formatIsoDate(value: string | null | undefined): string {
  if (!value) return "";
  try {
    return new Intl.DateTimeFormat("it-IT", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(value));
  } catch {
    return value;
  }
}

export function humanInterval(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) return `${Math.round(seconds / 60)} min`;
  return `${Math.round(seconds / 3600)} h`;
}
